import React from "react";
import PropTypes from "prop-types";
import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@material-ui/core";

import SelectorBuscable from "./SelectorBuscable";
import {
  TIPO_BUSCABLE,
  TIPO_FECHA,
  TIPO_HORA,
  TIPO_NUMERO,
  TIPO_SELECT,
} from "../model/campos";

// Particularidades de cada tipo de input, en un solo sitio.
const PROPS_POR_TIPO = {
  [TIPO_FECHA]: { InputLabelProps: { shrink: true } },
  [TIPO_HORA]: { InputLabelProps: { shrink: true }, inputProps: { step: 300 } },
  [TIPO_NUMERO]: { inputProps: { min: "0", step: "1" } },
};

/**
 * Pinta un campo a partir de su descriptor (ver model/campos.js). Evita
 * repetir el mismo bloque de TextField/Select una vez por campo.
 *
 * `ayuda` es un texto informativo bajo el campo (por ejemplo, mientras se
 * consultan las materias). El error manda: si lo hay, se muestra ese.
 */
const CampoFormulario = ({ campo, valor, error, ayuda, onChange, opciones }) => {
  const { name, label, tipo } = campo;
  const mensaje = error || ayuda;

  if (tipo === TIPO_BUSCABLE) {
    return (
      <SelectorBuscable
        etiqueta={label}
        valor={valor}
        opciones={opciones}
        onChange={(value) => onChange({ target: { name, value } })}
        error={error}
        ayuda={ayuda}
      />
    );
  }

  if (tipo === TIPO_SELECT) {
    return (
      <FormControl className="form-control" fullWidth error={Boolean(error)}>
        <InputLabel>{label}</InputLabel>
        <Select value={valor} name={name} onChange={onChange}>
          {opciones.map(({ id, nombre }) => (
            <MenuItem key={id} value={id}>
              {nombre}
            </MenuItem>
          ))}
        </Select>
        {mensaje && <FormHelperText>{mensaje}</FormHelperText>}
      </FormControl>
    );
  }

  return (
    <TextField
      value={valor}
      name={name}
      type={tipo}
      label={label}
      fullWidth
      onChange={onChange}
      error={Boolean(error)}
      helperText={mensaje}
      {...PROPS_POR_TIPO[tipo]}
    />
  );
};

CampoFormulario.propTypes = {
  campo: PropTypes.shape({
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    tipo: PropTypes.string.isRequired,
  }).isRequired,
  valor: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  error: PropTypes.string,
  ayuda: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  opciones: PropTypes.array,
};

CampoFormulario.defaultProps = { valor: "", error: "", ayuda: "", opciones: [] };

export default CampoFormulario;
